import React, { FC } from 'react';
import { Table } from 'components/organisms/projects-report/common';
import { DateRange } from 'components/organisms/projects-report/common/range-picker/types';
import { UsersReportRecord } from '../../types';
import { useColumnsConfig } from './columns';

export const UsersReportTable: FC<{
  usersReportRecords: UsersReportRecord[];
  range: DateRange;
}> = ({ usersReportRecords, range }) => {
  const columns = useColumnsConfig(usersReportRecords.length, range);

  return <Table columns={columns} dataSource={usersReportRecords} />;
};
